import { render } from "./UserQueryView.vue?vue&type=template&id=6b522204&scoped=true"
import script from "./UserQueryView.vue?vue&type=script&lang=js"
export * from "./UserQueryView.vue?vue&type=script&lang=js"

import "./UserQueryView.vue?vue&type=style&index=0&id=6b522204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b522204"]])

export default __exports__